import { render, staticRenderFns } from "./Xianjinribao.vue?vue&type=template&id=2bda0f59&scoped=true&"
import script from "./Xianjinribao.vue?vue&type=script&lang=js&"
export * from "./Xianjinribao.vue?vue&type=script&lang=js&"
import style0 from "./Xianjinribao.vue?vue&type=style&index=0&id=2bda0f59&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bda0f59",
  null
  
)

export default component.exports